
const socialIcons = {
    twitter: {
        // xdQaType: "tweet",
        src: "assets/x-icon-white.png",
        scale: .5,
        background: "black",
    },
    // meta: {
    // //     xdQaType: "tweet",
    //     src: "assets/twitter-icon-dark.png",
    // },
    linkedin: {
        // xdQaType: "linkedin",
        src: "assets/linkedin-icon-dark.png",
        background: "white",
    },
    pinterest: {
        // xdQaType: "pin",
        src: "assets/pinterest.svg",
        background: "white",
    },
};

export const socialToIcon   = (socialType) => socialIcons[socialType];
